import React from 'react';

export default ({onClick}) => {
  return (
    <button onClick={onClick} className="uk-button uk-button-link uk-button-small" uk-tooltip="Edit Environment">
      Edit
    </button>
  );
};
